<template>
  <router-view v-slot="{ Component }">
    <GlobalLoading />
    <component :is="Component" />
  </router-view>
</template>
<script setup>
import GlobalLoading from '@/components/loadingCom';
import {onMounted} from "vue";

onMounted(()=>{

})
// 解决el-table 报错
const debounce = (callback, delay) => {
  let tid;
  return function (...args) {
    const ctx = self;
    tid && clearTimeout(tid);
    tid = setTimeout(() => {
      callback.apply(ctx, args);
    }, delay);
  };
};

const _= window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends _{
  constructor(callback) {
    callback = debounce(callback,20)
    super(callback);
  }
}
</script>
<style lang="scss">

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  width: 100%;
  //min-height: 100vh;
  height: 100%;

}
</style>
